import Dexie, { type EntityTable } from 'dexie';
import type {
  Ability,
  ActionDefinition,
  EncounterGroup,
  Monster,
  PlayerCharacter,
} from '../domain/types';

export class DndDatabase extends Dexie {
  monsters!: EntityTable<Monster, 'id'>;
  pcs!: EntityTable<PlayerCharacter, 'id'>;
  actions!: EntityTable<ActionDefinition, 'id'>;
  abilities!: EntityTable<Ability, 'id'>;
  encounterGroups!: EntityTable<EncounterGroup, 'id'>;

  constructor() {
    super('dnd-assist-react');
    this.version(1).stores({
      monsters: 'id, name, cr, *types, isDefault',
      pcs: 'id, name, isDefault',
      actions: 'id, name, type, section',
      abilities: 'id, name',
      encounterGroups: 'id, name',
    });
  }
}

export const db = new DndDatabase();
